module.exports = __webpack_public_path__ + "media/images/redesign-images/rewards/loyalty-level-2-76f2c8f5fc3e18d26dcb826528e03b0e.svg";